import {
  CANDIDATE_COUNT,
  CANDIDATE_COUNT_SUCCESSFUL,
  CANDIDATE_COUNT_FAILED,
  CANDIDATE_SEARCH_COUNT,
  CANDIDATE_SEARCH_COUNT_SUCCESSFUL,
  CANDIDATE_SEARCH_COUNT_FAILED
} from "./actionTypes"

const initialState = {
  candidateCountError: null,
  message: null,
  loading: false,
  user: null,
}

const getCandidateCount = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_COUNT:
      state = {
        ...state,
        loading: true,
        candidateCountError: null,
      }
      break
    case CANDIDATE_COUNT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        candidateCountError: null,
      }
      break
    case CANDIDATE_COUNT_FAILED:
     
      state = {
        ...state,
        user: null,
        loading: false,
        candidateCountError: action.payload,
      }
      break
      case CANDIDATE_SEARCH_COUNT:
      state = {
        ...state,
        loading: true,
        candidateCountError: null,
      }
      break
      case  CANDIDATE_SEARCH_COUNT_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          user:action.payload,
          candidateCountError: null,
        }
        break
        case CANDIDATE_SEARCH_COUNT_FAILED:
          state = {
            ...state,
            loading: false,
            candidateCountError: action.payload,
          }
          break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getCandidateCount
